module.exports = require("./../../_gen/starling/rendering/RenderState");